/** @jsx isolateComponent */
import {
  Image,
  ImageProps,
} from '@zapier/common-components/src/components/Image';
import { isolateComponent } from '@zapier/common-utils';
import { useStaticAssetPath } from '../StaticAssetProvider';

type StaticImageProps = ImageProps & {
  /** Image path */
  src: string;
};

const StaticImage = ({ src, ...props }: StaticImageProps) => {
  const { buildStaticAssetUrl } = useStaticAssetPath();
  return <Image {...props} src={buildStaticAssetUrl(src)} />;
};

export default StaticImage;
